import React, { PureComponent, Fragment } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment';
import Icon from '../Icon/Icon';
import TimePublishModal from '../TimePublishModal/TimePublishModal';
import style from './TimePublishToolbar.scss';

export default class TimePublishToolbar extends PureComponent {
  state = {
    modalVisible: false,
  };

  openTimePublishModal = () => {
    this.setState({
      modalVisible: true,
    });
  };

  closeTimePublishModal = () => {
    this.setState({
      modalVisible: false,
    });
  };

  render() {
    const { note } = this.props;
    const publishTime = note.get('schedule_publish_at'); // 定时发布时间
    const shared = note.get('shared'); // 是否发布

    // 如果是定时发布，才显示
    if (publishTime && !shared) {
      const noteId = note.get('id');
      return (
        <Fragment>
          <div className={style.wrapper}>
            <div className={style.time}>
              <Icon name="clock-o"/>
              文章已设定{moment.unix(publishTime).format('YYYY-MM-DD HH:mm')}发布
            </div>
            <div className={style.btn} onClick={this.openTimePublishModal}>修改时间</div>
          </div>
          <TimePublishModal
            noteId={noteId.toString()}
            initialTime={publishTime}
            visible={this.state.modalVisible}
            onClose={this.closeTimePublishModal}
          />
        </Fragment>
      );
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/TimePublishToolbar/TimePublishToolbar.js